import { useQuery } from 'react-query';
import RestHttpClient from '../../../common/RestHttpClient';

export const dashboardPreliminaryQueryKey = (showAll: boolean, applicationState?: number) =>
  ['dashboard', 'preliminary', showAll, applicationState] as const;

export function usePreliminaryQuery(showAll: boolean, applicationState?: number) {
  return useQuery({
    queryKey: dashboardPreliminaryQueryKey(showAll, applicationState),
    queryFn: async () => {
      const { data } = await RestHttpClient.getPriliminaryContracts(showAll, applicationState);
      return data;
    },
    keepPreviousData: true,
    staleTime: 60_000,
  });
}
